import _ from 'lodash';

const request = async (data) => {
    let param = {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        address: '',
        params: '',
        body: null,
    };
    data = _.extend(param, data);
    
    let response = await fetch(data.address + data.params, {
        method: data.method.toUpperCase(),
        headers: data.headers,
        cache: 'no-cache',
        body: data.body
    });
    
    return await response.json();
}

const fs = {
    'axis-one': { // app
        // функциия получения данных для корзины
        getUser: async (params) => {
            let result1, result2, result3, result4,
                address = 'https://app.axis.trademaster.pro/api/app.php',
                data = '',
                find = null;

            let client_id = location.query && location.query.client_id ? location.query.client_id : params.client_id,
                lid_id = location.query && location.query.lidID ? location.query.lidID : params.lidID;

            if (client_id && lid_id) {
                data = `?client_id=${client_id}&path=leads/${lid_id}?with=contacts`;
                result1 = await request({method: 'get', address: address + data});

                if (
                    result1 &&
                    result1['_embedded'] &&
                    result1['_embedded']['contacts'] &&
                    result1['_embedded']['contacts'].length
                ) {
                    let contact = result1['_embedded']['contacts'].find((el) => el.is_main);

                    if (contact) {
                        data = `?client_id=${client_id}&path=contacts/${contact['id']}?with=contacts`;
                        result2 = await request({method: 'get', address: address + data});

                        let contact_name = result2.name;

                        if (
                            result2 &&
                            result2['_embedded'] &&
                            result2['_embedded']['companies'] &&
                            result2['_embedded']['companies'][0] &&
                            result2['_embedded']['companies'][0]['id']
                        ) {
                            data = `?client_id=${client_id}&path=companies/${result2['_embedded']['companies'][0]['id']}`;
                            result4 = await request({method: 'get', address: address + data});

                            contact_name = result4.name;

                            /*find = _.find(result4.custom_fields_values, (item) => item.field_name === 'ИНН');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                contact_name += ' ИНН ' + find.values[0].value;
                            }*/
                        }

                        if (result1.responsible_user_id) {
                            data = `?client_id=${client_id}&path=users/${result1.responsible_user_id}`;
                            result3 = await request({method: 'get', address: address + data});
                        }

                        if (result1.name) {
                            let nomDoc = params.nom,
                                nomDocStr = params.nom,
                                fio = contact_name,
                                address = '',
                                tel = '',
                                email = '',
                                note = [];

                            /*find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Номер расчета');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                nomDoc = nomDocStr = find.values[0].value;
                            }*/

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Адрес объекта');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                address = find.values[0].value;
                            }

                            find = _.find(result2.custom_fields_values, (item) => item.field_name === 'Телефон');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                tel = find.values[0].value;
                            }

                            find = _.find(result2.custom_fields_values, (item) => item.field_name === 'Email');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                email = find.values[0].value;
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Тип договора');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'ПФ Налогообложение');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push( find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Номер договора');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Дата договора');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push((new Date(find.values[0].value * 1000)).toLocaleDateString());
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Сумма предоплаты');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            // Ответственный по сделке
                            if (result3 && result3.name) {
                                note.push(result3.name);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Наличие лифта');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Паркинг разгрузка');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            return {nomDoc, nomDocStr, fio, tel, email, address, note: note.join('|')};
                        }
                    }
                }
            }
            
            return {};
        },
        
        // отправка номера документа
        sendNomDoc: async (params, nomDoc, cart_items) => {
            let address = 'https://app.axis.trademaster.pro/api/app.php',
                data = '',
                summa = 0;

            let client_id = location.query && location.query.client_id ? location.query.client_id : params.client_id,
                lid_id = location.query && location.query.lidID ? location.query.lidID : params.lidID;

            if (client_id && lid_id) {
                data = `?client_id=${client_id}&path=leads/${lid_id}?with=contacts`;

                cart_items.filter((el) => el.type !== 'услуги').map((el) => summa += +el.price.rozn);

                let json = JSON.stringify({
                    "price": summa,

                    "custom_fields_values": [
                        {
                            "field_id": +params.field,
                            "field_code": null,
                            "field_type": "url",
                            "values": [
                                {
                                    "value": "https://axis.trademaster.pro/reportViborka.aspx?nom="+nomDoc.toString() +"&vid=16&print=0&height=1000&width=800&nomStr="+nomDoc.toString()+"&apikey="+APP_TYPE
                                }
                            ]
                        }
                    ]
                });

                let xhr = new XMLHttpRequest();
                xhr.open("PATCH", address + data, true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send(json);
            }
        },
    },

    'profile-doors': {
        // функциия получения данных для корзины
        getUser: async (params) => {
            let result1, result2, result3, result4,
                address = 'https://profiledoors.axis.trademaster.pro/api/profiledoors.php',
                data = '',
                find = null;

            let lid_id = location.query && location.query.lidID ? location.query.lidID : params.lidID;

            if (lid_id) {
                data = `?path=leads/${lid_id}?with=contacts`;
                result1 = await request({method: 'get', address: address + data});

                if (
                    result1 &&
                    result1['_embedded'] &&
                    result1['_embedded']['contacts'] &&
                    result1['_embedded']['contacts'].length
                ) {
                    let contact = result1['_embedded']['contacts'].find((el) => el.is_main);

                    if (contact) {
                        data = `?path=contacts/${contact['id']}?with=contacts`;
                        result2 = await request({method: 'get', address: address + data});

                        let contact_name = result2.name;

                        if (
                            result2 &&
                            result2['_embedded'] &&
                            result2['_embedded']['companies'] &&
                            result2['_embedded']['companies'][0] &&
                            result2['_embedded']['companies'][0]['id']
                        ) {
                            data = `?path=companies/${result2['_embedded']['companies'][0]['id']}`;
                            result4 = await request({method: 'get', address: address + data});

                            contact_name = result4.name;

                            /*find = _.find(result4.custom_fields_values, (item) => item.field_name === 'ИНН');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                contact_name += ' ИНН ' + find.values[0].value;
                            }*/
                        }

                        if (result1.responsible_user_id) {
                            data = `?path=users/${result1.responsible_user_id}`;
                            result3 = await request({method: 'get', address: address + data});
                        }

                        if (result1.name) {
                            let nomDoc = params.nom,
                                nomDocStr = params.nom,
                                fio = contact_name,
                                address = '',
                                tel = '',
                                email = '',
                                note = [];

                            /*find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Номер расчета');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                nomDoc = nomDocStr = find.values[0].value;
                            }*/

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Адрес объекта');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                address = find.values[0].value;
                            }

                            find = _.find(result2.custom_fields_values, (item) => item.field_name === 'Телефон');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                tel = find.values[0].value;
                            }

                            find = _.find(result2.custom_fields_values, (item) => item.field_name === 'Email');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                email = find.values[0].value;
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Тип договора');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'ПФ Налогообложение');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push( find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Номер договора');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Дата договора');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push((new Date(find.values[0].value * 1000)).toLocaleDateString());
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Сумма предоплаты');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            // Ответственный по сделке
                            if (result3 && result3.name) {
                                note.push(result3.name);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Наличие лифта');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            find = _.find(result1.custom_fields_values, (item) => item.field_name === 'Паркинг разгрузка');
                            if (find && find.values && find.values[0] && find.values[0].value) {
                                note.push(find.values[0].value);
                            }else{
                                note.push(' ');
                            }

                            return {nomDoc, nomDocStr, fio, tel, email, address, note: note.join('|')};
                        }
                    }
                }
            }

            return {};
        },

        // отправка номера документа
        sendNomDoc: async (params, nomDoc, cart_items) => {
            let address = 'https://profiledoors.axis.trademaster.pro/api/profiledoors.php',
                data = '',
                summa = 0;

            let lid_id = location.query && location.query.lidID ? location.query.lidID : params.lidID;

            if (lid_id && params.docName) {
                data = `?path=leads/${lid_id}?with=contacts`;

                cart_items.filter((el) => el.type !== 'услуги').map((el) => summa += +el.price.rozn);

                let json = JSON.stringify({
                    "price": summa,

                    "custom_fields_values": [
                        {
                            "field_id": +params.field,
                            "field_code": null,
                            "field_type": "url",
                            "values": [
                                {
                                    "value": "https://axis.trademaster.pro/reportViborka.aspx?nom="+nomDoc.toString()+"&docName="+params.docName+"&vid=16&print=0&height=1000&width=800&nomStr="+nomDoc.toString()+"&apikey="+APP_TYPE
                                }
                            ]
                        }
                    ]
                });

                let xhr = new XMLHttpRequest();
                    xhr.open("PATCH", address + data, true);
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.send(json);
            }
        },
    }
};

export default fs;
